import { CatalogBusinessRoleProfileDto } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { nameOfFactory } from "@libs/utils/name-of.utils.ts";

export interface CreateUserFormValues {
  title: string | undefined;
  firstName: string;
  preferredName: string;
  middleName: string;
  lastName: string;
  username: string;
  phone: string;
  businessRoles: string[];
  medicareProviderNumber: string;
  ahpraNumber: string;
}

export interface BusinessRoleProfile {
  code: string;
  profile: CatalogBusinessRoleProfileDto | undefined;
}

export const nameOf = nameOfFactory<CreateUserFormValues>();
